/**
 * @file ppde页精选项目
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import classNames from 'classnames';
import {IFeaturedCasesItemProps} from './types.d';
import A from '../../../../components/a/A';

const FeaturedCasesItem: React.FC<IFeaturedCasesItemProps> = (props) => {
    const {
        className,
        title,
        subtitle,
        text,
        link,
        size,
        img
    } = props;

    return (
        <A
            href={link}
            target
        >
            <div
                className={classNames(
                    'paddle-ppde-fc-item',
                    className,
                    size === 'large' && 'paddle-ppde-fc-item-large'
                )}
                style={{backgroundImage: img ? `url(${img})` : undefined}}
            >
                <div className="paddle-ppde-fc-item-titles">
                    <div className="paddle-ppde-fc-item-title">
                        {title}
                    </div>
                    <div className="paddle-ppde-fc-item-subtitle">
                        {subtitle}
                    </div>
                </div>
                <div className="paddle-ppde-fc-item-text-wrap">
                    <div
                        className="paddle-ppde-fc-item-text"
                        dangerouslySetInnerHTML={{__html: text || ''}}
                    />
                </div>
            </div>
        </A>
    );
};

export default FeaturedCasesItem;
